import { render } from "./integrationsSetUp.vue?vue&type=template&id=05342772&scoped=true"
import script from "./integrationsSetUp.vue?vue&type=script&lang=js"
export * from "./integrationsSetUp.vue?vue&type=script&lang=js"

import "./integrationsSetUp.vue?vue&type=style&index=0&id=05342772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05342772"]])

export default __exports__